import { gql, useMutation } from '@apollo/client'
import { useAlert, useNotification } from '@btime/react-messager'
import { assoc, compose, pick } from 'ramda'
import { accountsClient } from '../../../apollo/api'

const cleanContract = compose(
  pick(['groupId', 'profileId']),
  item => assoc('groupId', item.group?.id || null, item),
  item => assoc('deleted', false, item),
  item => assoc('profileId', item.profile?.id, item)
)

const cleanRequest = compose(
  pick(['id', 'name', 'email', 'contract']), //
  item => assoc('contract', cleanContract(item.contract || {}), item)
)

const MUTATION = gql`
  mutation UpdateUser($id: Int, $input: UserInput) {
    updateUser(id: $id, input: $input) {
      id
    }
  }
`

export const useRecoverDeletedContract = () => {
  const [request, state] = useMutation(MUTATION, {
    refetchQueries: ['Contracts', 'ContractsCount', 'Users', 'UsersCount', 'User'],
    client: accountsClient
  })
  const notify = useNotification()
  const modal = useAlert()

  const handleRequest = user => {
    if (!modal.confirm({ title: 'Tem certeza que deseja recuperar este usuário?' })) return false

    const input = cleanRequest(user)

    return request({
      variables: { id: user.id, input }
    }).then(resp => {
      if (!!resp.errors) {
        notify.error({ title: 'Ocorreu um erro ao recuperar!' })
      }
    })
  }

  return [handleRequest, state]
}
